import React, { PureComponent } from 'react';
import cn from 'classnames'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import ShopTheLookLink from "../ShopThLook/ShopTheLookLink"

class GalleryItem extends PureComponent {

    _setContainerRef = (ref) => this._containerRef = ref;
    _setButtonRef = (ref) => this._buttonRef = ref;

    render() {
        const {classes, item, className, image, video, aspect} = this.props;

      // Need the key on the packery container so that packery is re-rendered
      return <div className={cn(classes.container, className)} >
          <div ref={this._setContainerRef}>
          <ImageOrVideo images={image} video={video} aspect={aspect} parallax={false} link={item.link} />
          {item.shopItems && item.shopItems.length > 0 &&
              <ShopTheLookLink className={classes.shopLink} title={item.shop_the_look_title} image={image || (video && video.image)} shopItems={item.shopItems} setRef={this._setButtonRef}/>
          }
          </div>
      </div>
    }
}

export default injectSheet(theme => ({
    shopLink: {
        willChange: 'transform'
    }
}))(GalleryItem);



// WEBPACK FOOTER //
// ./src/components/Lookbook/GalleryItem.js